import type { SubscriptionTier } from "./types";

// Local mirror of backend/app/core/config.py MONTHLY_DEAL_LIMIT_SELLER_* —
// deal creation is gated against this codebase config directly (not the
// live admin-config-backed usage endpoint), unlike web-frontend which relies
// on the backend's MONTHLY_QUOTA_EXCEEDED error. Keep these numbers in sync
// with config.py by hand when the backend defaults change.
// -1 = unlimited, 0 = not available.
export const MONTHLY_DEAL_LIMIT_SELLER: Record<SubscriptionTier, number> = {
  free: 100,
  starter: 20,
  mid: 80,
  premium: 300,
  pro: 0,
  studio: 0,
  elite: 0,
};

export function getMonthlyDealLimit(tier: SubscriptionTier | null): number {
  if (!tier) return MONTHLY_DEAL_LIMIT_SELLER.free;
  return MONTHLY_DEAL_LIMIT_SELLER[tier] ?? MONTHLY_DEAL_LIMIT_SELLER.free;
}

/** True when `count` deals already created this calendar month meet/exceed the tier's limit. -1 (unlimited) never blocks. */
export function hasReachedMonthlyDealLimit(tier: SubscriptionTier | null, countThisMonth: number): boolean {
  const limit = getMonthlyDealLimit(tier);
  if (limit < 0) return false;
  return countThisMonth >= limit;
}

export function countDealsThisMonth(createdAtDates: string[]): number {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  return createdAtDates.filter((iso) => {
    const d = new Date(iso);
    return d.getUTCFullYear() === year && d.getUTCMonth() === month;
  }).length;
}
